module.exports = __webpack_public_path__ + "img/derivePdfWhite.49141fb6.svg";